(function () {
  var toggle = document.querySelector('[data-ug-menu-toggle]');
  var drawer = document.querySelector('[data-ug-drawer]');
  if (!toggle || !drawer) return;

  // `position: fixed` is relative to the viewport UNLESS an ancestor has a transform/filter/
  // will-change (Shopify's page-transition CSS on `main` does exactly that) — in which case fixed
  // pins to THAT ancestor's box instead and scrolls away with the page. Moving the drawer to be a
  // direct child of <body> sidesteps the whole problem regardless of what the theme does upstream.
  document.body.appendChild(drawer);

  function setOpen(open) {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    drawer.hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  toggle.addEventListener('click', function () {
    setOpen(toggle.getAttribute('aria-expanded') !== 'true');
  });

  drawer.addEventListener('click', function (e) {
    if (e.target.tagName === 'A') setOpen(false);
  });

  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });

  // A resize into desktop width should never leave the drawer open underneath the (now hidden) toggle.
  var mq = window.matchMedia('(min-width: 900px)');
  mq.addEventListener('change', function (e) {
    if (e.matches) setOpen(false);
  });
})();
